var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{class:_vm.errorClassOnNull(_vm.item.name),attrs:{"taggable":"","placeholder":"Choose One","value":_vm.item,"options":_vm.itemOptions,"create-option":(name) => ({
        name: name,
        category_1: null,
        category_2: null,
        unit_price: 0,
      }),"label":"name"},on:{"search":_vm.fetchItemsOptions,"input":_vm.itemSelected},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('div',[_c('span',{staticClass:"text-bold text-capitalize"},[_vm._v(_vm._s(option.name))]),_c('br'),_vm._v(" "),(option.category_1)?_c('span',[_vm._v(_vm._s(option.category_1))]):_vm._e(),_vm._v(" "),(option.category_2)?_c('span',[_vm._v(" | "+_vm._s(option.category_2))]):_vm._e()])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }